import { useCallback, useEffect, useState } from "react";
import { TrendingUp, Flame } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { useSync } from "@/lib/live";

export const AdminForecast = () => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin/forecast").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useSync(load);
  if (!d) return <p className="text-[#7B968B]">Loading…</p>;
  const max = Math.max(1, ...d.days.map((x) => x.expected));
  return (
    <div className="max-w-5xl space-y-4" data-testid="admin-forecast">
      <div className="flex flex-wrap gap-3">
        {[["Trend vs earlier weeks", `${d.trend >= 1 ? "+" : ""}${Math.round((d.trend - 1) * 100)}%`], ["Busiest time slot", d.peak_slot || "-"], ["Based on bookings (8 weeks)", d.based_on]].map(([l, v]) => (
          <div key={l} className="rounded-2xl border border-[#D2E0D8] bg-white px-4 py-3"><p className="text-xs text-[#7B968B]">{l}</p><p className="font-display text-xl font-extrabold text-[#0D3B2B]">{v}</p></div>
        ))}
      </div>
      <p className="text-sm text-[#4A6358]">Expected pickups for the next 7 days, learned from the last 8 weeks of bookings by area and weekday. <b className="text-[#E05C3A]">Surge</b> = an area expected to be at least 1.5x busier than usual. Keep partners online nearby.</p>
      <div className="space-y-2">
        {d.days.map((x) => (
          <div key={x.date} className="rounded-2xl border border-[#D2E0D8] bg-white p-4" data-testid={`forecast-${x.date}`}>
            <div className="flex items-center justify-between gap-3">
              <p className="w-36 shrink-0 font-bold text-[#0D3B2B]">{fmtDate(x.date)}</p>
              <div className="h-3 flex-1 overflow-hidden rounded-full bg-[#F4F8F5]"><div className="h-full rounded-full bg-[#2E9E6B]" style={{ width: `${(x.expected / max) * 100}%` }} /></div>
              <p className="flex w-24 shrink-0 items-center justify-end gap-1 text-sm font-bold"><TrendingUp className="h-4 w-4 text-[#2E9E6B]" />~{x.expected}</p>
            </div>
            {x.areas.length > 0 && <p className="mt-2 flex flex-wrap gap-2 text-xs">{x.areas.map((a) => (
              <span key={a.zone} className={`rounded-full px-2 py-0.5 ${a.surge ? "bg-[#FDF0EC] font-bold text-[#E05C3A]" : "bg-[#F4F8F5] text-[#4A6358]"}`}>{a.surge && <Flame className="mr-0.5 inline h-3 w-3" />}{a.area} ~{a.expected}</span>
            ))}</p>}
          </div>
        ))}
      </div>
      {!d.based_on && <p className="rounded-2xl bg-white p-4 text-sm text-[#7B968B]">Not enough bookings yet. The forecast improves automatically as bookings come in.</p>}
    </div>
  );
};
